import React, { useRef, useState, useMemo, useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "../css/textEditor.module.css";
import { AiOutlineTable } from "react-icons/ai";
/* QuillReactEditor.jsx (with disable feature) */

const EDITOR_WRAPPER_STYLE = {
  background: "#e4f2e6",
  borderRadius: "10px",
};

const injectBrandingStyles = () => {
  const css = `
    .ql-toolbar button:hover, .ql-snow .ql-stroke { stroke: #205a46; }
    .ql-container.ql-snow {
      background: white;
      border-radius: 6px;
      border-top: 0 !important;
    }
    .ql-snow .ql-stroke {
      stroke-width: 1.4 !important;
    }
    .ql-snow .ql-fill {
      stroke-width: 1 !important;
    }
    .ql-snow .ql-editor.ql-blank::before {
      font-family: 'DM Sans', sans-serif !important;
      font-style: normal !important;
      font-weight: 400 !important;
      opacity: 1 !important;
    }
    .ql-snow .ql-editor {
      font-family: 'DM Sans', sans-serif !important;
    }
    .ql-custom-table-btn {
      font-size: 18px;
      padding: 0 8px;
      color: #205a46 !important;
      border: 1px solid #eaeeed;
      border-radius: 4px;
      cursor: pointer;
      background: white;
    }
    .ql-custom-table-btn:hover {
      background: #e4f2e6;
    }
    .ql-toolbar,
    .ql-toolbar * ,
    .ql-container,
    .ql-editor,
    .ql-picker,
    .ql-picker-label,
    .ql-picker-item {
      font-family: "DM Sans" !important;
    }
     .ql-snow .ql-toolbar .ql-picker-label:hover,
    .ql-snow .ql-toolbar .ql-picker-label:focus,
    .ql-snow .ql-toolbar .ql-picker.ql-expanded .ql-picker-label {
      color: #205a46 !important;       
      border-color: #eaeeed !important;  
      background: #ffffff !important;
    }
    // .ql-toolbar .ql-picker-label {
    //   border: 1px solid #eaeeed !important;
    //   border-radius: 6px;
    //   padding: 2px 10px;
    //   background: #e4f2e6;
    // }


  `;
  const existing = document.getElementById("quill-brand-styles");
  if (existing) return;
  const style = document.createElement("style");
  style.id = "quill-brand-styles";
  style.appendChild(document.createTextNode(css));
  document.head.appendChild(style);
};

function TableGrid({ onSelect }) {
  const rows = 10;
  const cols = 10;

  const [hR, setHR] = useState(0);
  const [hC, setHC] = useState(0);

  return (
    <div
      style={{
        position: "absolute",
        top: 40,
        left: 0,
        background: "#fff",
        padding: 10,
        borderRadius: 8,
        boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
        zIndex: 9999,
      }}
    >
      {[...Array(rows)].map((_, r) => (
        <div key={r} style={{ display: "flex" }}>
          {[...Array(cols)].map((_, c) => {
            const active = r < hR && c < hC;
            return (
              <div
                key={c}
                onMouseEnter={() => {
                  setHR(r + 1);
                  setHC(c + 1);
                }}
                onClick={() => onSelect(r + 1, c + 1)}
                style={{
                  width: 20,
                  height: 20,
                  margin: 2,
                  border: "1px solid #ccc",
                  background: active ? "#b6e8c4" : "#fff",
                  cursor: "pointer",
                }}
              />
            );
          })}
        </div>
      ))}

      <div style={{ marginTop: 5, textAlign: "center" }}>
        {hR} × {hC}
      </div>
    </div>
  );
}

export default function QuillReactEditor({
  value: initialValue = `<p><strong>Bold Text</strong></p><p><em>Italic Text</em></p>`,
  onChange,
  uploadUrl = "/api/upload",
  useBase64Fallback = true,
  disabled = false,     // NEW PARAM
  greyToolbar = false, 
}) {
  const quillRef = useRef(null);
  const [value, setValue] = useState(initialValue);
  const [showTableGrid, setShowTableGrid] = useState(false);

  const isDisabled = disabled;

  // unique toolbar id per instance
  const toolbarIdRef = useRef(`toolbar-${Math.random().toString(36).slice(2, 9)}`);

  // useEffect(() => {
  //   injectBrandingStyles();
  // }, []);

  useEffect(() => {
  injectBrandingStyles();

 if (greyToolbar) {
  const style = document.createElement("style");
  style.id = "quill-grey-style-" + toolbarIdRef.current;

  style.innerHTML = `
    #${toolbarIdRef.current} {
      background: #eaeeed !important;
      border: 1px solid #d6dada !important;
      border-bottom: none !important;
    }

    #${toolbarIdRef.current} + .ql-container {
      border: 1px solid #d6dada !important;
      border-top: none !important;
    }
  `;

  document.head.appendChild(style);
}

}, [greyToolbar]);


  // Apply readOnly mode
  useEffect(() => {
    if (quillRef.current) {
      const editor = quillRef.current.getEditor();
      editor.enable(!isDisabled);
    }
  }, [isDisabled]);

  const insertTable = (rows, cols) => {
    if (isDisabled) return;

    let html = "<table style='border-collapse: collapse; width:100%;'>";
    for (let r = 0; r < rows; r++) {
      html += "<tr>";
      for (let c = 0; c < cols; c++) {
        html += "<td style='border:1px solid #ccc; padding:8px; min-width:80px;'></td>";
      }
      html += "</tr>";
    }
    html += "</table>";

    const editor = quillRef.current.getEditor();
    const range = editor.getSelection(true);
    editor.clipboard.dangerouslyPasteHTML(range.index, html);

    setShowTableGrid(false);
  };

  const modules = useMemo(
    () => ({
      toolbar: {
        container: `#${toolbarIdRef.current}`,
        handlers: {
          insertTable: () => {
            if (isDisabled) return;
            setShowTableGrid((prev) => !prev);
          },
          image: function () {
            if (isDisabled) return;

            const input = document.createElement("input");
            input.setAttribute("type", "file");
            input.setAttribute("accept", "image/*");
            input.click();

            input.onchange = async () => {
              const file = input.files?.[0];
              if (!file) return;

              const editor = this.quill;
              const range = editor.getSelection(true);
              editor.insertEmbed(
                range.index,
                "image",
                "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw=="
              );

              try {
                const url = await uploadImageWithFallback(
                  file,
                  uploadUrl,
                  useBase64Fallback
                );
                editor.deleteText(range.index, 1);
                editor.insertEmbed(range.index, "image", url);
              } catch (e) {
                console.error(e);
                editor.deleteText(range.index, 1);
                alert("Image upload failed");
              }
            };
          },
        },
      },
      clipboard: { matchVisual: false },
      history: { delay: 2000, maxStack: 500, userOnly: true },
    }),
    [uploadUrl, useBase64Fallback, isDisabled]
  );

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "video",
    "color",
    "background",
    "align",
  ];

  async function uploadImageWithFallback(file, url, base64Fallback) {
    try {
      const form = new FormData();
      form.append("file", file);
      const resp = await fetch(url, { method: "POST", body: form });
      if (!resp.ok) throw new Error("upload failed");
      const json = await resp.json();
      return json.url;
    } catch (e) {
      if (base64Fallback) return await fileToDataUrl(file);
      throw e;
    }
  }

  function fileToDataUrl(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => resolve(e.target.result);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  const handleChange = (content, delta, source, editor) => {
    if (isDisabled) return; // block text edits completely
    const html = editor.getHTML();
    const text = editor.getText();
    setValue(content);
    onChange?.({ html: html, text: text });
  };

  return (
    <div className={greyToolbar ? "quill-grey-toolbar" : ""}  style={EDITOR_WRAPPER_STYLE}>
      <div
        id={toolbarIdRef.current}
        style={{
          position: "relative",
          borderRadius: "10px 10px 0px 0px",
          marginTop: "-33px",
          pointerEvents: isDisabled ? "none" : "auto",
          opacity: isDisabled ? 0.5 : 1,
        }}
      >
        <select className="ql-header" defaultValue="">
          <option value="1"></option>
          <option value="2"></option>
          <option value=""></option>
        </select>

        <button className="ql-bold"></button>
        <button className="ql-italic"></button>
        <button className="ql-underline"></button>

        <button className="ql-list" value="ordered"></button>
        <button className="ql-list" value="bullet"></button>

        <button className="ql-link"></button>
        <button className="ql-image"></button>

        <button
          className="ql-custom-table-btn ql-insertTable"
          onClick={() => !isDisabled && setShowTableGrid((s) => !s)}
        >
         <span> <AiOutlineTable /></span> 
        </button>

        {showTableGrid && !isDisabled && <TableGrid onSelect={insertTable} />}
      </div>

      <ReactQuill
        ref={quillRef}
        theme="snow"
        value={value}
        onChange={handleChange}
        modules={modules}
        formats={formats}
        placeholder="Start writing..."
      />
    </div>
  );
}
